import * as z from 'zod';

/**
 * Build-time configuration, validated once.
 *
 * Mirrors the backend's approach on purpose: configuration is parsed at a single
 * boundary and fails loudly, rather than being read as `import.meta.env.X` from
 * wherever it happens to be needed.
 */
const environmentSchema = z.object({
  VITE_API_URL: z.url().default('http://localhost:3000'),
});

export const environment = environmentSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
});
